import { ProductType } from 'src/app/enum/product-type';

export class Drug {
  public constructor() {
    this.id = '';
    this.name = '';
    this.persianName = '';
    this.attachment = '';
    this.sellPrice = 0;
    this.buyPrice = 0;
    this.flavor = '';
    this.drugGenericName = '';
    this.drugGenericId = '';
    this.drugFormName = '';
    this.drugFormId = '';
    this.drugUsageName = '';
    this.drugUsageId = '00000000-0000-0000-0000-000000000000';
    this.creatorCompanyName = '';
    this.creatorCompanyId = '00000000-0000-0000-0000-000000000000';
    this.countryName = '';
    this.countryId = '00000000-0000-0000-0000-000000000000';
    this.drugPackageCount = 0;
    this.keepingTypeName = '';
    this.keepingTypeId = '00000000-0000-0000-0000-000000000000';
    this.licenseCompanyName = '';
    this.licenseCompanyId = '00000000-0000-0000-0000-000000000000';
    this.productTypeName = '';
    this.productTypeEnum = ProductType.ChemicalDrug;
  }

  public id: string;
  public name: string;
  public nameHint?: string;
  public persianName: string;
  public persianNameHint?: string;
  public attachment: string;
  public attachmentHint?: string;
  public sellPrice: number;
  public costHint?: string;
  public buyPrice: number;
  public buyPriceHint?: string;
  public flavor: string;
  public flavorHint?: string;
  public drugGenericName: string;
  public drugGenericId: string;
  public drugGenericHint?: string;
  public drugFormName: string;
  public drugFormId: string;
  public drugFormHint?: string;
  public drugUsageName: string;
  public drugUsageId: string;
  public drugUsageHint?: string;
  public creatorCompanyName: string;
  public creatorCompanyId: string;
  public creatorCompanyHint?: string;
  public countryName: string;
  public countryId: string;
  public countryHint?: string;
  public drugPackageCount: number;
  public drugPackageHint?: string;
  public keepingTypeName: string;
  public keepingTypeId: string;
  public keepingTypeHint?: string;
  public licenseCompanyName: string;
  public licenseCompanyId: string;
  public licenseCompanyHint?: string;
  public productTypeName: string;
  public productType?: number;
  public productTypeEnum: ProductType;
  public productTypeHint?: string;

  public drugCodes:DrugCode[]=[];
}

export class DrugCode {
  public constructor(

  ) {
  }

  public id?:string;
  public erxCode?: string;
  public ERXHint?: string;
  public irc?: string;
  public IRCHint?: string;
  public gtn?: string;
  public GTNHint?: string;
  public barCode?: string;
  public BarcodeHint?: string;
  public drugId?:string;
}

export class DrugBackEndModel {
  public constructor() {
    this.name = '';
    this.persianName = '';
    this.attachment = '';
    this.sellPrice = 0;
    this.buyPrice = 0;
    this.flavor = '';
    this.drugGenericId = '';
    this.drugFormId = '';
    this.drugUsageId = '00000000-0000-0000-0000-000000000000';
    this.creatorCompanyId = '00000000-0000-0000-0000-000000000000';
    this.countryId = '00000000-0000-0000-0000-000000000000';
    this.drugPackageCount = 1;
    this.keepingTypeId = '00000000-0000-0000-0000-000000000000';
    this.licenseCompanyId = '00000000-0000-0000-0000-000000000000';
  }

  public name: string;
  public persianName: string;
  public attachment: string;
  public sellPrice: number;
  public buyPrice: number;
  public flavor: string;
  public drugGenericId: string;
  public drugFormId: string;
  public drugUsageId: string;
  public creatorCompanyId: string;
  public countryId: string;
  public drugPackageCount: number;
  public keepingTypeId: string;
  public licenseCompanyId: string;
  public productTypeEnum?: number;
}
